import React from "react";

// BTS logo — abstract growth chart above three connected human figures
// Reflects the visiting card design (yellow + black brand).
export const BtsLogo = ({ size = 40, withText = true, className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Behavioural Training Spectrum logo"
      >
        {/* yellow tile behind icon */}
        <rect x="0" y="0" width="48" height="48" fill="#FFDA00" />
        {/* growth chart */}
        <polyline
          points="8,20 16,14 24,18 32,10 40,6"
          stroke="#0A0A0A"
          strokeWidth="2.2"
          fill="none"
          strokeLinecap="square"
          strokeLinejoin="miter"
        />
        <circle cx="40" cy="6" r="2" fill="#0A0A0A" />
        {/* three connected figures */}
        <g stroke="#0A0A0A" strokeWidth="2" fill="none">
          <circle cx="14" cy="30" r="2.6" />
          <circle cx="24" cy="30" r="2.6" />
          <circle cx="34" cy="30" r="2.6" />
          <path d="M9 42c1.5-4 4-6 5-6M39 42c-1.5-4-4-6-5-6M19 42c1-4 3-6 5-6s4 2 5 6" />
        </g>
      </svg>
      {withText && (
        <div className="leading-none">
          <div className="font-display text-[17px] tracking-tight text-black">
            Behavioural Training
          </div>
          <div className="font-display text-[17px] tracking-tight text-black -mt-0.5">
            Spectrum<span className="text-[color:var(--bts-yellow)]">.</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default BtsLogo;
